import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HardscapingPage from "../pages/services/hardscaping/page";
import AboutPage from "../pages/about/page";
import ColoradoSpringsPage from "../pages/locations/colorado-springs/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/services/hardscaping", element: <HardscapingPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/locations/colorado-springs", element: <ColoradoSpringsPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
